import { createSlice } from "@reduxjs/toolkit";

export const requestSlice = createSlice({
  name: "request",
  initialState: {
  requestDetails:null
  },
  reducers: {
    setRequestDetails: (state, action) => {
      state.requestDetails = action.payload;
    },
   
  },
});

export const { setRequestDetails } = requestSlice.actions;

export default requestSlice.reducer;
